import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';

import { saveCreateOrderPayload } from '../../../redux/actions';

const NCRPOrderConfirmation = props => {
	const {
		user: { selectedAccount, selectedPriceSource },
		order: { createOrderPayload }
	} = useSelector(({ user, order }) => ({ user, order }));
	const dispatch = useDispatch();

	useEffect(() => {
		if (!createOrderPayload) {
			browserHistory.replace('/ncrp-order');
		} else {
			return () => {
				dispatch(saveCreateOrderPayload(null));
			};
		}
	}, []);

	const { items, orderDetails, shipTo, billTo } = createOrderPayload || {};

	if (!orderDetails) {
		return null;
	}

	const { totalQuantity } = useMemo(
		() =>
			(items &&
				items.reduce(
					(acc, cur) => ({
						totalQuantity: +acc.totalQuantity + +cur.requestedQuantity
					}),
					{
						totalQuantity: 0
					}
				)) ||
			{},
		[orderDetails]
	);

	return (
		<div className="ncrpOrderConfirmation">
			<p className="textRight">
				<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={props.handlePrint} href="">
					Print Order Confirmation
				</a>
			</p>
			<div className="smallPush">
				<h1 className="pageTitle">Order Confirmation</h1>
			</div>
			<p>
				<strong>Order Reference #:</strong> {orderDetails.P_HEADER_REC.ORIG_SYS_DOCUMENT_REF}
			</p>
			{/* <p className="pNetOrderConfirmationPrintOnly">
				<strong>Account:</strong> {selectedAccount && `${selectedAccount.ACCOUNTNUMBER} - ${selectedAccount.ACCOUNTDESCRIPTION}`}
			</p>
			<p className="pNetOrderConfirmationPrintOnly">
				<strong>Sales Agreement:</strong> {selectedPriceSource && selectedPriceSource.AGREEMENT_NAME}
			</p> */}
			<div className="orderReviewColumns columns threeColumns" style={{ lineHeight: '1.1rem' }}>
				<div className="orderReviewColumn column column1">
					<p>
						{orderDetails.P_HEADER_REC.ATTRIBUTE2 && (
							<React.Fragment>
								<strong>Order started by:</strong> {orderDetails.P_HEADER_REC.ATTRIBUTE2}
								<br />
							</React.Fragment>
						)}
						<strong>Customer P.O.:</strong> {orderDetails.P_HEADER_REC.CUST_PO_NUMBER}
						<br />
						<strong>Requested Ship Date:</strong> {orderDetails.P_HEADER_REC.REQUEST_DATE && props.formatDate(orderDetails.P_HEADER_REC.REQUEST_DATE, 'MM/DD/YY')}
					</p>
				</div>
				<div className="orderReviewColumn column column2">
					{shipTo && (
						<p>
							<strong>Ship to:</strong>
							<br />
							{shipTo.NAME && (
								<React.Fragment>
									{shipTo.NAME}
									<br />
								</React.Fragment>
							)}
							{shipTo.ADDRESS1}
							<br />
							{shipTo.ADDRESS2 && (
								<React.Fragment>
									{shipTo.ADDRESS2}
									<br />
								</React.Fragment>
							)}
							{shipTo.ADDRESS3 && (
								<React.Fragment>
									{shipTo.ADDRESS3}
									<br />
								</React.Fragment>
							)}
							{shipTo.CITY}, {shipTo.STATE || shipTo.PROVINCE}, {shipTo.COUNTRY}, {shipTo.POSTALCODE}
							<br />
						</p>
					)}
					<p>
						{orderDetails.P_HEADER_VAL_REC.SHIPPING_METHOD && (
							<React.Fragment>
								<strong>Shipping Method:</strong> {orderDetails.P_HEADER_VAL_REC.SHIPPING_METHOD}
								<br />
							</React.Fragment>
						)}
						<strong>Order Type:</strong> {orderDetails.P_HEADER_VAL_REC.SHIPMENT_PRIORITY && orderDetails.P_HEADER_VAL_REC.SHIPMENT_PRIORITY.split('-').at(1)}
						<br />
						{orderDetails.P_HEADER_REC.ATTRIBUTE8 && (
							<React.Fragment>
								<strong>Delivery Phone:</strong> {props.normalizePhoneNumber(orderDetails.P_HEADER_REC.ATTRIBUTE8)}
								<br />
							</React.Fragment>
						)}
					</p>
				</div>
				<div className="orderReviewColumn column column3">
					{billTo && (
						<p>
							<strong>Bill to:</strong>
							<br />
							{billTo.NAME && (
								<React.Fragment>
									{billTo.NAME}
									<br />
								</React.Fragment>
							)}
							{billTo.ADDRESS1}
							<br />
							{billTo.ADDRESS2 && (
								<React.Fragment>
									{billTo.ADDRESS2}
									<br />
								</React.Fragment>
							)}
							{billTo.CITY}, {billTo.STATE || billTo.PROVINCE}, {billTo.COUNTRY}, {billTo.POSTALCODE}
							<br />
						</p>
					)}
				</div>
			</div>

			<table className="orderReviewTable dataTableType2 noRowBorders milktoast">
				<thead>
					<tr>
						<th>Item</th>
						<th>Original Item</th>
						<th>Item Description</th>
						<th className="text-right">Order Qty</th>
						<th>Status</th>
						<th>ETA</th>
						<th>Customer Reference</th>
					</tr>
				</thead>
				<tbody>
					{items &&
						items.map((item, index) => {
							const isQuantityNotAvailableOnRequestedDate =
								item.itemDetails && item.itemDetails.availabilityData && item.itemDetails.availabilityData.availableQuantity >= 1410065408;
							return (
								<tr key={index}>
									<td>{item.itemNumber}</td>
									<td>{item.originalItemNumber}</td>
									<td>{item.itemDetails && item.itemDetails.pimData && item.itemDetails.pimData.item_description}</td>
									<td className="text-right">{item.requestedQuantity}</td>
									<td>{isQuantityNotAvailableOnRequestedDate ? 'Backorder' : 'Available'}</td>
									<td>
										{isQuantityNotAvailableOnRequestedDate &&
											item.itemDetails &&
											item.itemDetails.availabilityData &&
											item.itemDetails.availabilityData.shipDate &&
											moment(item.itemDetails.availabilityData.shipDate, 'DD-MMM-YY').format('MM/DD/YYYY')}
									</td>
									<td>{item.customerReference}</td>
								</tr>
							);
						})}
				</tbody>
				<tfoot>
					<tr>
						<td colSpan={3}>Total Items</td>
						<td className="text-right">{totalQuantity}</td>
						<td colSpan={3}></td>
					</tr>
				</tfoot>
			</table>
		</div>
	);
};

export default NCRPOrderConfirmation;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/ncrpOrderConfirmation.jsx